enum ExperienceType {
  ANGRY = 'angry',
  SAD = 'sad',
  NEUTRAL = 'neutral',
  HAPPY = 'happy',
  EXCITED = 'excited',
}

export default ExperienceType;
